export default __webpack_public_path__ + "static/media/ag-white.2f04338c.svg";